<template>
    <div class="home">
        <i-row>
            <i-col span="24">
                <i-carousel autoplay loop>
                    <i-carouselItem v-for="item in slideDate">
                        <div class="carousel"><img class="carousel_img" :src="url + item.path"/></div>
                    </i-carouselItem>
                </i-carousel>
            </i-col>
        </i-row>
        <i-row class="margintop">
            <!--大赛新闻 登录-->
            <i-col span="24">
                <i-col span="16">
                    <div style="text-align: center">
                        <div>
                            <em class="line-l" style="width: 35%;right: 18px !important;"></em>
                        </div>
                        <div>
                            <span class="title_head">大赛新闻</span>
                            <br/>
                            <span class="lang_eng">COMPETTITION NEWS</span>
                        </div>
                        <div>
                            <em class="line-r" style="width: 35%;left: 18px;"></em>
                        </div>
                    </div>
                    <div style="text-align: center;padding:25px">
                        <i-row>
                            <i-col span="1" offset="21" style="cursor: pointer;">
                                <router-link to="info/news">更多</router-link>
                            </i-col>
                            <i-col span="10" offset="1">
                                <i-carousel autoplay loop>
                                    <i-carouselItem v-for="item in slideDate2">
                                        <div><img style="height: 200px;width: 100%;" class="carousel_img"
                                                  :src="url + item.path"/>
                                        </div>
                                    </i-carouselItem>
                                </i-carousel>
                            </i-col>
                            <i-col span="12" style="margin-left: 15px;">
                                <div class="articletitle">
                                    <i-row>
                                        <i-col span="24" v-for="item in data" @click.native="newsdetails(item)">
                                            <i-col span="19">
                                                <p class="title123">{{ item.title }}</p>
                                            </i-col>
                                            <i-col span="5">
                                                <p style="font-size: 14px">{{ item.create_time|formatDate }}</p>
                                            </i-col>
                                        </i-col>
                                    </i-row>
                                </div>
                            </i-col>
                        </i-row>
                    </div>
                </i-col>
                <i-col span="8" v-if="state">
                    <div style="text-align: center">
                        <div>
                            <em class="line-r" style="width: 30%;left: 18px"></em>
                        </div>
                        <div>
                            <span class="title_head">参赛登录</span>
                            <br/>
                            <span class="lang_eng">LOGIN</span>
                        </div>
                        <div>
                            <em class="line-l" style="width: 30%;right: 18px !important;"></em>
                        </div>
                    </div>
                    <div style="text-align: center; padding: 25px;">
                        <div class="login">
                            <div class="login-box">
                                <Card class="login-form">
                                    <Form :model="loginForm" :rules="loginRules" ref="loginForm">
                                        <FormItem prop="email" ref="login_email">
                                            <Input v-model="loginForm.email" type="text" prefix="ios-contact"
                                                   @on-enter="login"
                                                   placeholder="请输入用户名"></Input>
                                        </FormItem>
                                        <FormItem prop="password" ref="login_password">
                                            <Input v-model="loginForm.password" type="password" prefix="md-key"
                                                   @on-enter="login"
                                                   placeholder="请输入密码"></Input>
                                        </FormItem>
                                    </Form>
                                    <Button type="info" long @click="login" class="viclie">登录</Button><br/>
                                    <router-link to="/forget"><<<< 忘记密码</router-link>
                                    <router-link to="/register" style="margin-left: 30%;">注册>>>></router-link>
                                </Card>
                            </div>
                        </div>

                    </div>
                </i-col>
                <i-col span="8" v-if="!state">
                    <div style="text-align: center">
                        <div>
                            <em class="line-r" style="width: 20%;left: 15px"></em>
                        </div>
                        <div>
                            <span class="title_head">个人中心</span>
                            <br/>
                            <span class="lang_eng">PERSONAL CENTER</span>
                        </div>
                        <div>
                            <em class="line-l" style="width: 20%;right: 15px !important;"></em>
                        </div>
                    </div>
                    <div style="text-align: center; padding: 54px 30px 30px;">
                        <div class="teamdeal" @click="teamdeal()">
                            <Icon type="ios-people-outline" style="font-size: 80px"/>
                            团队管理
                        </div>
                    </div>
                </i-col>
            </i-col>
            <!--大赛宣传片 大赛选题-->
            <i-col span="24">
                <i-col span="10">
                    <div style="text-align: center">
                        <div>
                            <em class="line-r" style="width: 30%;left: 10px"></em>
                        </div>
                        <div>
                            <span class="title_head">大赛宣传片</span>
                            <br/>
                            <span class="lang_eng">CONTEST VIDEO</span>
                        </div>
                        <div>
                            <em class="line-l" style="width: 30%;right: 10px !important;"></em>
                        </div>
                    </div>
                    <div style="text-align: center; padding: 25px;">
                        <!--<embed-->
                        <!--src="https://imgcache.qq.com/tencentvideo_v1/playerv3/TPout.swf?max_age=86400&v=20161117&vid=z0505qamqhi&auto=0"-->
                        <!--allowfullscreen="true" quality="high" width="430" height="260" style="margin-top:20px"-->
                        <!--align="middle" allowscriptaccess="always" type="application/x-shockwave-flash">-->
                        <!--<video src="http://player.youku.com/embed/XNDExMjU5MTY1Ng==" type="application/x-shockwave-flash" controls="controls" style="width: 430px;height: 260px;">-->
                        <!--your browser does not support the video tag-->
                        <!--</video>-->
                        <!--<embed src="http://player.youku.com/embed/XNDExMjU5MTY1Ng==" allowfullscreen="true" quality="high" width="410" height="260" style="margin-top:20px" align="middle" allowscriptaccess="always" type="application/x-shockwave-flash">-->
                        <iframe height=340 width=410 src='http://player.youku.com/embed/XNDExMjU5MTY1Ng==' frameborder=0>
                        </iframe>
<!--                        <embed src='http://player.youku.com/player.php/sid/XNDExMjU5MTY1Ng==/v.swf'-->
<!--                               allowFullScreen='true' quality='high' width='410' height='340' align='middle'-->
<!--                               allowScriptAccess='always' type='application/x-shockwave-flash'>-->
                    </div>
                </i-col>
                <i-col span="14">
                    <div style="text-align: center">
                        <div>
                            <em class="line-r" style="width: 32%;left: 10px"></em>
                        </div>
                        <div>
                            <span class="title_head">大赛选题</span>
                            <br/>
                            <span class="lang_eng">COMPETTITION TOPICS</span>
                        </div>
                        <div>
                            <em class="line-l" style="width: 32%;right: 10px !important;"></em>
                        </div>
                    </div>
                    <div style="text-align: center;padding:25px">

                        <i-row style="line-height: 1.6">
                            <i-col span="24" v-for="item in selected" @click.native="Topicsdetails(item)">
                                <i-col span="2">
                                    <p class="title121">选题{{ arr[item.class_name] }}</p>
                                </i-col>
                                <i-col span="22">
                                    <p class="title321">{{ item.topic_name }}</p>
                                </i-col>
                            </i-col>
                        </i-row>

                    </div>
                </i-col>
            </i-col>
            <!--选题企业-->
            <i-col span="24">
                <i-col span="24">
                    <div style="text-align: center">
                        <div>
                            <em class="line-r" style="width: 36%;left: 10px"></em>
                        </div>
                        <div>
                            <span class="title_head">选题企业</span>
                            <br/>
                            <span class="lang_eng">TOPIC SELECTION ENTERPRISE</span>
                        </div>
                        <div>
                            <em class="line-l" style="width: 36%;right: 10px !important;"></em>
                        </div>
                    </div>
                    <div style="text-align: center;padding-top:25px">
                        <i-row>
                            <i-col span="4">
                                <br>
                            </i-col>
                            <i-col span="4" v-for="item in company" style="margin-bottom: 10px;">
                                <i-col span="2">
                                    <br>
                                </i-col>
                                <i-col span="20">
                                    <div style="border-radius: 15px;" @click="companydetails(item)">
                                        <img :src="url + item.path" style="width: 100%"></div>
                                </i-col>
                            </i-col>
                        </i-row>
                    </div>
                </i-col>
            </i-col>
            <!--专家评委-->
            <i-col span="24">
                <i-col span="24">
                    <div style="text-align: center">
                        <div>
                            <em class="line-r" style="width: 42%;left: 10px"></em>
                        </div>
                        <div>
                            <span class="title_head">专家评委</span>
                            <br/>
                            <span class="lang_eng">THE JUDGE</span>
                        </div>
                        <div>
                            <em class="line-l" style="width: 42%;right: 10px !important;"></em>
                        </div>
                    </div>
                    <div style="text-align: center;padding:25px">
                        <i-row>
                            <i-col span="2">
                                <br>
                            </i-col>
                            <i-col span="20">
                                <div v-for="item in techlogo"
                                     style="text-align: center;width: 14.28%;float: left;padding: 0 10px 10px 10px;"
                                     @click="Judgesdetails(item)">
                                    <img :src="url + item.image"
                                         style="width: 100px;height: 100px;border-radius: 100px">
                                    <div class="break"><a>{{ item.company }}</a></div>
                                    <div style="width: 100%">{{ item.judge_name }}</div>
                                </div>
                            </i-col>
                        </i-row>
                    </div>
                </i-col>
            </i-col>
            <!--校园活动-->
            <i-col span="24">
                <i-col span="15">
                    <div style="text-align: center">
                        <div>
                            <em class="line-r" style="width: 36%;left: 10px"></em>
                        </div>
                        <div>
                            <span class="title_head">校园活动</span>
                            <br/>
                            <span class="lang_eng">CAMPUS ACTIVITIES</span>
                        </div>
                        <div>
                            <em class="line-l" style="width: 36%;right: 10px !important;"></em>
                        </div>
                    </div>
                    <i-col span="20" offset="2">
                        <div style="text-align: center;">
                            <i-carousel autoplay loop :autoplay-speed="speed" :autoplay="false">
                                <i-carouselItem v-for="item in active">
                                    <div class="carousel"><img class="carousel_img" :src="url + item.path"/></div>
                                </i-carouselItem>
                            </i-carousel>
                        </div>
                    </i-col>
                </i-col>
                <i-col span="9">
                    <div style="text-align: center">
                        <div>
                            <em class="line-r" style="width: 32%;left: 10px"></em>
                        </div>
                        <div>
                            <span class="title_head">往届参赛作品</span>
                            <br/>
                            <span class="lang_eng">REVIEW</span>
                        </div>
                        <div>
                            <em class="line-l" style="width: 32%;right: 10px !important;"></em>
                        </div>
                    </div>
                    <div style="text-align: center;padding:15px">
                        <i-row style="height: 388px;overflow-y:scroll;">
                            <i-col span="11" v-for="item in works" style="padding: 15px;cursor: pointer" offset="1">
                                <img :src="item.url" @click="worksdetails(item.id)" style="width: 150px;height: 100px">
                            </i-col>
                        </i-row>
                    </div>
                </i-col>
            </i-col>
            <!--第六届大赛回顾-->
            <i-col span="24">
                <div style="text-align: center">
                    <div>
                        <em class="line-r" style="width: 40%;left: 10px"></em>
                    </div>
                    <div>
                        <span class="title_head">第六届大赛回顾</span>
                        <br/>
                        <span class="lang_eng">REVIEW</span>
                    </div>
                    <div>
                        <em class="line-l" style="width: 40%;right: 10px !important;"></em>
                    </div>
                </div>
                <div style="text-align: center;padding:25px">
                    <a href="http://cusprpc2017.cipra.org.cn/">
                        <img
                                :src="url+'/upload/pastimg/666.png'"
                                style="width: 100%">
                    </a>
                </div>
            </i-col>
            <!--实习基地-->
            <i-col span="24">
                <div style="text-align: center">
                    <div>
                        <em class="line-r" style="width: 40%;left: 10px"></em>
                    </div>
                    <div>
                        <span class="title_head">实习基地</span>
                        <br/>
                        <span class="lang_eng">INTERNSHIP BASE</span>
                    </div>
                    <div>
                        <em class="line-l" style="width: 40%;right: 10px !important;"></em>
                    </div>
                </div>
                <div style="text-align: center;width: 80%;margin: 0 auto">
                    <div v-for="item in logo" style="width: 20%;float: left;padding: 30px">
                        <img :src="url + item.path" style="width: 100%;height: 50px;">
                    </div>
                    <!--<i-row>-->
                    <!--<i-col span="4" v-for="item in logo" style="margin-bottom: 50px;">-->
                    <!--&lt;!&ndash;<i-col span="4">&ndash;&gt;-->
                    <!--&lt;!&ndash;<br>&ndash;&gt;-->
                    <!--&lt;!&ndash;</i-col>&ndash;&gt;-->
                    <!--<i-col span="18">-->
                    <!--<img :src="url + item.path" style="width: 100%">-->
                    <!--</i-col>-->
                    <!--</i-col>-->
                    <!--</i-row>-->
                </div>
            </i-col>
        </i-row>
    </div>
</template>

<script>
    import {
        Icon,
        Col,
        Row,
        Carousel,
        CarouselItem,
        Breadcrumb,
        BreadcrumbItem,
        Menu,
        MenuGroup,
        MenuItem,
        Card,
        Form,
        FormItem,
        Input,
        Button
    } from 'iview';
    import {api_getData} from '../../api/carousel';
    import {api_getOthers} from '../../api/info';
    import {api_getselected, api_getdata, api_gettechlogo, api_getstate} from '../../api/home/home';
    import {api_signUp} from '../../api/login/login';
    import {formatDate} from '../../api/date.js';
    import {auth_key} from './../../config';
    import {url} from '../../config';

    export default {
        name: '',
        components: {
            Card,
            Form,
            FormItem,
            Input,
            Button,
            'i-col': Col,
            'i-row': Row,
            'i-icon': Icon,
            'i-carousel': Carousel,
            'i-carouselItem': CarouselItem,
            'i-breadcrumb': Breadcrumb,
            'i-breadcrumbItem': BreadcrumbItem,
            'i-menu': Menu,
            'i-menuGroup': MenuGroup,
            'i-menuItem': MenuItem,
        },

        data() {
            return {
                speed: 6000,
                state: true,
                arr: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],
                value: '',
                loginForm: {
                    email: '',
                    password: ''
                },
                loginRules: {
                    email: [
                        {required: true, message: '用户名不能为空', trigger: 'blur'},
                    ],
                    password: [
                        {required: true, message: '密码不能为空', trigger: 'blur'},
                    ]
                },
                value2: 0,
                works: [
                    {url: url + '/upload/wangjie/2.png', id: 2, name: '清华大学'},
                    {url: url + '/upload/wangjie/4.png', id: 4, name: '浙江传媒学院'},
                    {url: url + '/upload/wangjie/3.png', id: 3, name: '厦门大学'},
                    {url: url + '/upload/wangjie/6.png', id: 6, name: '中山大学'},
                    {url: url + '/upload/wangjie/1.png', id: 1, name: '复旦大学'},
                    {url: url + '/upload/wangjie/5.png', id: 5, name: '中国人民大学'}
                ],
                slideDate: [],
                slideDate2: [],
                url: url,
                details: '',
                // 实习基地
                logo: [],
                // 专家评委
                techlogo: [],
                // 新闻
                data: [],
                // 校园活动
                active: [],
                // 选题
                selected: [],
                // 选题企业
                company: [],
            }
        },
        filters: {
            formatDate(time) {
                var date = new Date(time * 1000);
                return formatDate(date, 'yyyy-MM-dd');
            },
        },
        async created() {
            // 获取登录状态
            let _vv = await api_getstate();
            let vvv = _vv.body;
            if (vvv.code === 0) {
                this.state = false;
                // console.log(rrr)
            }

            // 获取导航
            let _data = await api_getData('home');
            let res = _data.body;
            if (res.code === 0) {
                this.slideDate = res.data;
            }

            // 获取校园活动
            let _dddd = await api_getData('school');
            let eee = _dddd.body;
            if (eee.code === 0) {
                this.active = eee.data;
            }

            let _data2 = await api_getOthers('intro');
            let res2 = _data2.body;
            if (res2.code === 0) {
                this.details = res2.details;
            }

            // 获取新闻
            let _datt = await api_getData('news');
            let rex = _datt.body;
            if (rex.code === 0) {
                this.slideDate2 = rex.data;
            }


            // 获取新闻
            let _dttt = await api_getdata();
            let rrx = _dttt.body;
            if (rrx.code === 0) {
                this.data = rrx.data;
                // console.log(rrx)
            }

            // 获取选题
            let _dtta = await api_getselected();
            let rxx = _dtta.body;
            if (rxx.code === 0) {
                this.selected = rxx.data;
                // console.log(rxx)
            }

            // 获取企业
            let _company = await api_getData('company');
            let company = _company.body;
            if (company.code === 0) {
                this.company = company.data;
            }

            // 获取专家
            let _tttt = await api_gettechlogo();
            let rrr = _tttt.body;
            if (rrr.code === 0) {
                this.techlogo = rrr.data;
            }

            // 获取基地
            let _enterprise = await api_getData('enterprise');
            let enterprise = _enterprise.body;
            if (enterprise.code === 0) {
                this.logo = enterprise.data;
            }
        },
        methods: {

            async login() {
                let _bool = await this.$refs.loginForm.validate();
                // 验证通过
                if (_bool) {
                    this.$Message.loading({
                        duration: 0,
                        content: '登录中'
                    });
                    let _data = await api_signUp({
                        email: this.loginForm.email,
                        password: this.loginForm.password,
                    });
                    let res = _data.body;
                    this.$Message.destroy();
                    if (res.code === 0) {
                        this.$Message.success({
                            duration: 1.5,
                            content: res.msg,
                            onClose: () => {
                                sessionStorage.setItem(auth_key, res.key);
                                // this.$router.push({name: 'home'});
                                window.location.reload();
                            }
                        })
                    } else {
                        this.$Message.error({
                            content: res.msg
                        })
                    }
                }
            },
            // 选题详情
            Topicsdetails(data) {
                localStorage.setItem('details', JSON.stringify({
                    content: data,
                    title: '大赛选题',
                    englishtitle: 'COMPETITION TOPICS'
                }));
                this.$router.push({
                    name: 'details',
                });
                // console.log(data)
            },

            // 新闻详情
            newsdetails(data) {
                localStorage.setItem('details', JSON.stringify({
                    content: data,
                    title: '大赛新闻',
                    englishtitle: 'COMPETITION NEWS'
                }));
                this.$router.push({
                    name: 'details',
                });
                // console.log(data)
            },

            worksdetails(data) {
                localStorage.setItem('works', JSON.stringify({
                    content: data,
                    title: '往届作品',
                    englishtitle: 'PREVIOUS WORKS'
                }));
                this.$router.push({
                    name: 'works',
                });
            },

            // 专家评委详情
            Judgesdetails(data) {
                localStorage.setItem('details', JSON.stringify({
                    content: data,
                    title: '专家评委',
                    englishtitle: 'THE JUDGE'
                }));
                this.$router.push({
                    name: 'details',
                });
            },

            // 选题企业详情
            companydetails(data) {
                localStorage.setItem('details', JSON.stringify({
                    content: data,
                    title: '选题企业',
                    englishtitle: 'THE COMPANY'
                }));
                this.$router.push({
                    name: 'details',
                });
            },

            teamdeal() {
                this.$router.push({name: 'personal_create_team',});
            },
        }
    }
</script>

<style lang="scss">
    .home {

        .teamdeal {
            font-size: 30px;
            color: white;
            background-color: #9933cc;
            border-radius: 26px;
            padding: 27px;
            cursor: pointer;
        }

        .teamdeal:hover {
            background-color: #9e5bcc;
        }

        text-align: left;
        /*轮播图设置*/
        .carousel {
            .carousel_img {
                width: 100%;
                height: 100%;
            }
        }

        /*row间距设置*/
        .margintop {
            margin-top: 20px;

            /*长线*/
            .line-l::after, .line-r::after {
                content: '';
                position: absolute;
                right: -4px;
                top: -7px;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                border: 1px solid #8d40ef;
            }

            .line-l, .line-r {
                position: absolute;
                /*left: 0;*/
                top: 28px;
                width: 100px;
                height: 1px;
                background: #8d40ef;
            }

            em {
                font-size: 14px;
                font-weight: normal;
                font-style: normal;
                font-family: 微软雅黑, "Microsoft YaHei";
                margin: 0px;
                padding: 0px;
                list-style: none;
            }

            .line-r {
                right: 0;
                left: initial;
            }

            .line-r::after {
                left: -5px;
                right: initial;
            }

            .articletitle {
                /*color: rgb(153, 51, 255);*/
                height: 200px;
                width: 100%;
                /*background-color: #1abc9c;*/
                font-size: 11.5px;
                box-shadow: 5px 5px 10px #b878f9;
                padding: 8px 8px;
                line-height: 1.7;
            }

            .title123 {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                text-align: left;
                font-weight: bold;
                cursor: pointer;
            }

            .title321 {
                text-align: left;
                cursor: pointer;
                font-size: 15px;
                font-weight: bold;
            }

            .title121 {
                font-size: 15px;
                text-align: left;
                cursor: pointer;
                font-weight: bold;
            }

            /*登录*/
            .login {
                width: 100%;
                /*height: 100vh;*/
                /*padding-top: 6vh;*/
            }

            .viclie {
                border: 0px;
                width: 50%;
                height: 45px;
                margin: 0 auto;
                background-color: rgb(153, 51, 255);
                border-color: rgb(153, 51, 255);
                background: -webkit-linear-gradient(#a1a1f6, rgb(153, 51, 255)); /* Safari 5.1 - 6.0 */
                background: -o-linear-gradient(#a1a1f6, rgb(153, 51, 255)); /* Opera 11.1 - 12.0 */
                background: -moz-linear-gradient(#a1a1f6, rgb(153, 51, 255)); /* Firefox 3.6 - 15 */
                background: linear-gradient(#a1a1f6, rgb(153, 51, 255)); /* 标准的语法 */
            }

            .login-box {
                width: 85%;
                margin: auto;
                text-align: center;

                .login-form {
                    background-color: #fdfdfd;
                }
            }

            .break {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                font-weight: bold;
                color: black;
            }
        }

        /*菜单栏start*/
        .verticalMenu {
            .ivu-menu-light {
                background: #d9b2ff;
            }

            .ivu-menu {
                display: block;
                border-radius: 40px;
                overflow: hidden;
                color: #ffffff;
                font-size: 14px;
                position: relative;
            }

            .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
                color: #ffffff;
                font-weight: 600;
                background: rgb(153, 51, 255);
                z-index: 2;
            }

            .ivu-menu-vertical .ivu-menu-item:hover, .ivu-menu-vertical .ivu-menu-submenu-title:hover {
                color: #3d2404;
            }

            .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
                content: '';
                display: block;
                width: 2px;
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                background: #e5ea20;
            }
        }

        /*菜单栏end*/

        /*小标题start*/
        .title_head {
            color: #9933CC;
            font-weight: 600;
            font-size: 18px;
        }

        .lang_eng {
            /*color: rgb(255,165,51);*/
            font-size: 16px;
        }

        /*小标题end*/
    }
</style>
